module.exports = __webpack_public_path__ + "static/media/icon-cocktail-white.7aede711.svg";